export type AnyFunction<R = any> = (...a: any[]) => R;

export type ValueOf<T extends {}> = T[keyof T];

export interface IMap<T = any> {
	[key: string]: T;
}

// Object.entries et al lose typing of keys (instead of keyof T, you get string). These are alternatives
export const keysOf = <T extends {}, K extends keyof T>(o: T): K[] => Object.keys(o) as K[];
export const valuesOf = <T extends {}, V extends ValueOf<T>>(o: T): V[] => keysOf(o).map((k) => o[k]) as V[];
export const entriesOf = <T extends {}, K extends keyof T, V extends T[K]>(o: T): Array<[K, V]> => keysOf(o).map((k) => [k, o[k]]) as Array<[K, V]>;

// These just modify Parameters<> slightly to get the first param, or the tail params
export type FirstParameter<T extends (p1: any, ...args: any) => any> = T extends (p1: infer P, ...a: any[]) => any ? P : never;
export type TailParameters<T extends (p1: any, ...args: any) => any> = T extends (p1: any, ...a: infer P) => any ? P : never;

type bindFirstArg = <F extends (p1: any, ...args: any[]) => any>(fn: F, p: FirstParameter<F>) => (...params: TailParameters<F>) => ReturnType<F>;
export const bindFirstArg: bindFirstArg = (f, p) => (...params) => f(p, ...params);
